module.exports = __webpack_public_path__ + "static/painter-3c62aa7bff3cd8b1ba5b426aa8bcb38f.png";